import React from "react";
export const USERMENU = [
    {
        title: "Acciones",
        icon: <i className="pe-7s-car pe-lg"></i>,
        type: "link",
        path: `${process.env.REACT_APP_PUBLIC_URL}/dashboard/users/default`,
        children: [
            { title: "Usuario", type: "sub" },
            {
                title: "Procesos Activos",
                type: "link",
                path: `${process.env.REACT_APP_PUBLIC_URL}/pages/users/activeprocesses`,
            },
            { title: "Problemas", type: "sub" },
            {
                title: "Reportar Incidencia",
                type: "link",
                path: `${process.env.REACT_APP_PUBLIC_URL}/pages/users/activeprocesses`,
            },
        ]
    },
];